import { ApiClientErrorResponse } from '~/ApiClient';

export default class ProductPriceHistoryErrorResponse extends ApiClientErrorResponse {
	handleCustomerWithoutLicence(): boolean {
		return this.handle('customer-without-licence');
	}
}
